import React from 'react';
import '../less/index.less';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import hero_img from '../img/hero_img.png';
import hero_cards_img from '../img/hero_cards_img.png';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew'
import tariffsData from '../enums/tariffs_data.json';
import TextAboveFooterNew from '../../../../../auxiliary-components/shared/TextAboveFooterNew'
import DOMPurify from 'utils/sanitize';
import applyOrderItems from '../enums/apply_order_items.json';
import { Preloader } from 'MWComponents';
import { planetAvtoLink } from '../../../../../services/urls/urls';

export default function template() {
    const hero_data = {
      title: 'LEASING_NEW_HERO_TITLE',
      text: 'LEASING_NEW_HERO_TEXT',
      link: {
        text: "LEASING_NEW_HERO_BTN",
        onClick: () => window.open(planetAvtoLink, "_blank"),
      },
      cards: [
        {
          title: 'LEASING_NEW_CARDS_HERO_TITLE_01',
          imgBottom: hero_cards_img,
          altBottom: 'LEASING_NEW_CARDS_HERO_IMG_ALT_01'
        },
      ]
    };

    const filesForDownloadWidget = this.widgetsHelper.getWidget.call(this, 'files_to_download');

    return (
      <div className="module-leasing">
        <Hero
          data={hero_data}
          img={hero_img}
        />
        <div className="content">
          <Tariffs
            items={tariffsData}
            title={'LEASING_NEW_CARDS_TARIFFS_TITLE'}
          />
          <div className="apply-order">
            <div className="container">
              <div className="apply-order__body">
                <h2 className="apply-order__title">{this.l10n('LEASING_NEW_APPLY_ORDER_TITLE')}</h2>
                <div className="apply-order__row">
                  {applyOrderItems.map((item, index) => (
                    <div key={index} className="apply-order__item item-apply-order">
                      <div className="item-apply-order__title">{this.l10n(item.title)}</div>
                      <div
                        className="item-apply-order__text"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(this.l10n(item.text), {
                            ADD_ATTR: ['target']
                          }),
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {filesForDownloadWidget.data && filesForDownloadWidget.data.length ? (
            <>
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
              <TextAboveFooterNew
                widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
              />
            </>
          ) : <Preloader/>}
        </div>
      </div>
    );
}
